import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2380. 支払タスク費用科目削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_expense_account_items/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyPaymentTaskExpenseAccountItem = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_expense_account_items/${props.id}`
  );
};

export const useDestroyPaymentTaskExpenseAccountItem = () => {
  return useMutation({
    mutationFn: destroyPaymentTaskExpenseAccountItem,
  });
};
